import { useContext } from "react";
import { YearContext } from "../context";

export const useYear = () => useContext(YearContext);
